import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { TraceService } from '@sentry/angular';
import { provideToastr } from 'ngx-toastr';

import { routes } from './app.routes';
import { HttpCollectorInterceptor } from './core/http-store/http-collector.interceptor';
import { authInterceptor } from './auth/interceptors/auth-interceptor';
import { registerLocaleData } from '@angular/common';
import it from '@angular/common/locales/it';
import { AllEnterpriseModule, ModuleRegistry } from 'ag-grid-enterprise';

registerLocaleData(it);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideToastr(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpCollectorInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(TraceService);
      ModuleRegistry.registerModules([AllEnterpriseModule]);
    }),
    {
      provide: LOCALE_ID,
      useValue: 'it',
    },
  ],
};
